import {
    useCallback,
    useEffect,
    useState,
} from 'react';

import { Contract } from 'ethers';

import useConnectWallet from '@/store/wallet/useConnectWallet';

const useLpBalanceOf = (lpContract: Contract | null,) => {
    const [balanceLp, setBalanceLp] = useState(BigInt(0));
    const { address } = useConnectWallet();
    const [balanceLpLod, setLoading] = useState(false);
    const getBalanceLp = useCallback(async () => {
        try {
            if (lpContract) {
                setLoading(true);
                const balance = await lpContract.balanceOf(address);
                setBalanceLp(balance);
            }
        } catch (error) {
            console.log("Error fetching LP balance:", error);
        } finally {
            setLoading(false);
        }
    }, [address, lpContract])
    useEffect(() => {
        getBalanceLp()
    }, [getBalanceLp])
    return {
        balanceLp,
        balanceLpLod,
        getBalanceLp
    }
}

export default useLpBalanceOf